// Design tokens for use in inline styles and JS props (e.g. recharts, accentColor).
// Keep in sync with the `pokemon` palette in tailwind.config.js.
export const COLORS = {
  red:      '#e74c3c',
  redDark:  '#c0392b',
  blue:     '#3498db',
  blueDark: '#2980b9',
  green:    '#27ae60',
};
